import { CommonService } from './../../services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgForm } from '@angular/forms';
import { Operation } from 'src/app/model/operation';
import { DIMBO_CONSTANT } from './../../utils/constant';
import { CacheService } from './../../services/cache.service';
import { MaintenancePlanService } from './../../services/maintenance-plan.service';
import { AdditionalInfoDialogBoxComponent } from './../additional-info-dialog-box/additional-info-dialog-box.component';
import { Component, EventEmitter, OnInit, Output, OnChanges, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from  '@ngx-translate/core';
import * as _moment from 'moment';

@Component({
  selector: 'app-maintenance-plan',
  templateUrl: './maintenance-plan.component.html',
  styleUrls: ['./maintenance-plan.component.scss']
})
export class MaintenancePlanComponent implements OnInit, OnChanges {

  typesOfServices: any[] = [];
  numberOfServices: any[] = [];
  additionalInfoDialogBoxRef: any;
  showCurrentService: boolean;
  selectedOption: any[] = [];
  filteredOption: any[] = [];
  singleserviceoperation :Operation [] = [];
  issueDetected: boolean = false;
  antiperforationperiod: any;
  antiperforationcomment: any = "";
  servicehistorycomment: any = "";
  usage: string;
  services: any[] = [];
  maintenanceServices: any[] = [];
  numberOfYears: any;
  vehicleBrandIsNotOV: boolean = true;
  isAntiPerforationCheck: boolean;
  createServiceScope: boolean;
  isReadOnly: boolean = false;
  customerVeficationRetryCount:number;
  selectedVal: string;
  isMpSevereHasData: boolean = false;
  hasPlanned: boolean = false;
  
  @Input()
  isVehicleInfoUpdated: boolean; 

  @Output()
    switchToFirst: EventEmitter<{ isSwitchToFirst: boolean }> = new EventEmitter(); 

  @Output()
  onMaintenanceReload: EventEmitter<{ isVehicleUpdated: boolean}> = new EventEmitter();  
  
  @Output()
  onaddServiceReload: EventEmitter<{ reloadFirstTab: boolean}> = new EventEmitter(); 

  @Output() additionInfoUpdated: EventEmitter<{ isAdditionInfoUpdated: boolean}> = new EventEmitter(); 

  selectedYear: number;

  storedIndexArr: any[];
  storedIndexObj: any;
  selectedOpsForIndex: any[];

  @Input() isMaintenanceTabSelected: boolean;
  greaterage: number;
  normalHasdata: boolean =false;
  canceltranlation: any;
  submittranlation: any;

  constructor(
      private matDialog: MatDialog,
      private maintenancePlanService: MaintenancePlanService,
      private toastrService: ToastrService ,
      private translationService: TranslateService,
      private cacheService: CacheService,
      private spinner: NgxSpinnerService,
      private commonService: CommonService
    ) {
      this.numberOfYears = Array(11).fill(1).map((x,i)=>i).slice(1);
     }

  ngOnInit(): void {
    this.selectedVal = 'NORMAL';
    this.usage = 'NORMAL';
    this.showCurrentService = false;
    this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CREATE_SERVICE_SCOPE, this.showCurrentService);
    this.issueDetected = false;
    this.antiperforationcomment = '';
    //this.antiperforationperiod = 1;
    this.servicehistorycomment = '';
    this.singleserviceoperation = [];
    //this.getMaintenancePlan(this.usage);
    this.setContractId();
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) === 'OV' && this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_OV_LEGACY)) {
      this.vehicleBrandIsNotOV = false; 
    }
    this.createServiceScope = false;
    this.isAntiPerforationCheck = false;
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_CENTRAL_USER) === true || this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_ADMIN_USER) === true ) {
      this.isReadOnly = true; 
    } else {
      this.isReadOnly = false; 
    }
    this.customerVeficationRetryCount = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT);
    this.antiperforationperiod = this.getVehicleAge();
   // console.log('Vehicle age: ', this.antiperforationperiod);
    this.storedIndexArr = [];
    this.storedIndexObj = {};
    this.selectedOpsForIndex = [];
    this.canceltranlation=this.translationService.instant('dimbo.i18n.button.close');
    this.submittranlation=this.translationService.instant('dimbo.i18n.button.submit');
  }

  onPageLoad(): void {
    this.selectedVal = 'NORMAL';
    this.usage = 'NORMAL';
    this.showCurrentService = false;
    this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CREATE_SERVICE_SCOPE, this.showCurrentService);
    this.issueDetected = false;
    this.antiperforationcomment = '';
    //this.antiperforationperiod = 1;
    this.servicehistorycomment = '';
    this.singleserviceoperation = [];
    //this.getMaintenancePlan(this.usage);
    this.setContractId();
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) === 'OV' && this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_OV_LEGACY)) {
      this.vehicleBrandIsNotOV = false; 
    }
    this.createServiceScope = false;
    this.isAntiPerforationCheck = false;
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_CENTRAL_USER) === true || this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_ADMIN_USER) === true ) {
      this.isReadOnly = true; 
    } else {
      this.isReadOnly = false; 
    }
    this.customerVeficationRetryCount = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT);
    this.antiperforationperiod = this.getVehicleAge();
   // console.log('Vehicle age: ', this.antiperforationperiod);
    this.storedIndexArr = [];
    this.storedIndexObj = {};
    this.selectedOpsForIndex = [];
  }

  ngOnChanges() {
   if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) === 'OV' && this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_OV_LEGACY)) {
      this.vehicleBrandIsNotOV = false; 
    }
    if (this.isVehicleInfoUpdated) {
     // console.log('after updating vehicle info...');
      this.callMaintenancePlan('NORMAL');
      this.isVehicleInfoUpdated = false;
      this.onMaintenanceReload.emit({isVehicleUpdated: false});
      this.isMpSevereHasData = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_MP_SEVERE_HAS_DATA);
    }
    if (this.isMaintenanceTabSelected) {
      if(this.showCurrentService) {
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CREATE_SERVICE_SCOPE, true);
      }
      
    }
  }

   onValChange(val: string) {
    this.selectedVal = val;
    this.getMaintenancePlan(this.selectedVal);
  }

  getMaintenancePlan(usage: string){
    /* if(this.showCurrentService) {
      return false;
    } */
    this.usage = usage;
    this.spinner.show();
    this.typesOfServices.length = 0;
    this.numberOfServices.length = 0;

    /* let params: any = {
      language : 'fr',
      country: 'fr',
      mileageUnit: 'km',
      usage: usage,
      brand: 'AP',
      mileage: '12345'
    } */

    let vehicleMilleageUnite = 'yr,'+ this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT);

    let params: any = {
      language : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL),
      country: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY),
      unit: vehicleMilleageUnite,
      usage: usage,
      brand: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) ? 'AP' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND),
      mileage: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE),
      firstRegistrationDate: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE)
    }

    this.maintenancePlanService.getMaintenancePlan(params)
      .subscribe(response => {
        this.maintenanceServices = response;
        if (response && response.maintenancePlans[0].operations) {
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH, response.doesMileageUnitMatch);
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL, response.frequencyMileageUnit);
          for (const operation of response.maintenancePlans[0].operations) {
            let elm: any = {};
            elm.id = operation.reference;
            elm.serviceName = operation.operationLabel;
            elm.order = operation.order;
            elm.statusCode = operation.planningStatus?.code;
            elm.statusLabel = this.getStatusLabel(operation.planningStatus?.label);
            elm.stepFrequency = this.getStepFrequency(operation.steps);
            elm.source = !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION);
            elm.typeCode = '';
            
            this.services.push(elm);
          }
          this.hasPlanned=this.services.reduce((prev, service) => prev || service.statusLabel, false);
          this.normalHasdata=true;
          this.typesOfServices = this.services;
          this.numberOfServices.push(this.services);
          //this.numberOfServices = this.services;

        } else {
          this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.MP.vin'), this.translationService.instant('dimbo.i18n.message.toastr.warning'), {
            timeOut: 10000,
          });
        }

        this.spinner.hide();
                
        }, error => {
          this.spinner.hide();
          if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503 || error.status === 404) && error.error) {
            this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.MP.vin'), this.translationService.instant('dimbo.i18n.message.toastr.warning'), {
              timeOut: 10000,
            });
        } else {
          this.spinner.hide();
            this.toastrService.error(this.translationService.instant('dimbo.i18n.message.record.error'), this.translationService.instant('dimbo.i18n.message.toastr.error'), {
              timeOut: 10000,
            });
        }
        });
  }

  getStepFrequency(steps: any[]): string {
    let stepFrequency = '';
    if (steps.length === 1) {

      if (steps[0].cycle) {
        if (steps[0].init === steps[0].cycle) {
          if(steps[0].unit === 'Yr') {
            stepFrequency = this.translationService.instant('dimbo.i18n.label.fequency.everyUppercase')+' '+steps[0].init+' '+ this.translationService.instant('dimbo.i18n.label.fequency.years'); 
          } else if (steps[0].unit === 'Km') {
            stepFrequency = this.translationService.instant('dimbo.i18n.label.fequency.everyUppercase')+' '+steps[0].init+' '+ 'km'; 
          } else if (steps[0].unit === 'Mi') {
            stepFrequency = this.translationService.instant('dimbo.i18n.label.fequency.everyUppercase')+' '+steps[0].init+' '+ 'mi'; 
          } else {
    
          }  
        } else{
          if(steps[0].unit === 'Yr') {
            stepFrequency = steps[0].init+' '+ this.translationService.instant('dimbo.i18n.label.fequency.years') +' '+ this.translationService.instant('dimbo.i18n.label.fequency.then') +' '+ this.translationService.instant('dimbo.i18n.label.fequency.every')+' '+ steps[0].cycle+' '+ this.translationService.instant('dimbo.i18n.label.fequency.years'); 
          } else if (steps[0].unit === 'Km') {
            stepFrequency = steps[0].init+' km '+ this.translationService.instant('dimbo.i18n.label.fequency.then') +' '+ this.translationService.instant('dimbo.i18n.label.fequency.every')+' '+ steps[0].cycle+' km'; 
          } else if (steps[0].unit === 'Mi') {
            stepFrequency = steps[0].init+' '+ 'mi'; 
            stepFrequency = steps[0].init+' mi '+ this.translationService.instant('dimbo.i18n.label.fequency.then') +' '+ this.translationService.instant('dimbo.i18n.label.fequency.every')+' '+ steps[0].cycle+' mi';
          } else {
    
          }
        }
      } else { // when ther's no cyclic value
        if(steps[0].unit === 'Yr') {
          stepFrequency = steps[0].init+' '+ this.translationService.instant('dimbo.i18n.label.fequency.years'); 
        } else if (steps[0].unit === 'Km') {
          stepFrequency = steps[0].init+' '+ 'km'; 
        } else if (steps[0].unit === 'Mi') {
          stepFrequency = steps[0].init+' '+ 'mi'; 
        } else {

        }
      }

      

    } else if(steps.length === 2) {


      if (steps[0].cycle) {
        // case 1: When initial period &/or mileage is same as that of Cyclical values of period &/or mileage 
        if ((steps[0].init === steps[0].cycle) || (steps[1].init === steps[1].cycle)) {
          if (steps[1].unit === 'Km') {
            stepFrequency = this.translationService.instant('dimbo.i18n.label.fequency.everyUppercase')+' '+steps[1].init +' '+'km / '+steps[0].cycle+' '+this.translationService.instant('dimbo.i18n.label.fequency.years');  
          } else {
            stepFrequency = this.translationService.instant('dimbo.i18n.label.fequency.everyUppercase')+' '+steps[1].init +' '+'mi / '+steps[0].cycle+' '+this.translationService.instant('dimbo.i18n.label.fequency.years');   
          }  
        } else {
          // case 2: When initial period &/or mileage is different as that of Cyclical values of period &/or mileage 
          if (steps[1].cycle === 0){
            if (steps[1].unit === 'Km') {
               stepFrequency = steps[1].init +' '+'km / '+steps[0].init+' '+this.translationService.instant('dimbo.i18n.label.fequency.years')+' '+this.translationService.instant('dimbo.i18n.label.fequency.then')+' '+this.translationService.instant('dimbo.i18n.label.fequency.every') + ' ' + steps[0].cycle+' '+this.translationService.instant('dimbo.i18n.label.fequency.years');  
             } else {
               stepFrequency = steps[1].init +' '+'mi / '+steps[0].init+' '+this.translationService.instant('dimbo.i18n.label.fequency.years')+' '+this.translationService.instant('dimbo.i18n.label.fequency.then') +' '+' '+this.translationService.instant('dimbo.i18n.label.fequency.every') + ' '+ steps[0].cycle+' '+this.translationService.instant('dimbo.i18n.label.fequency.years');  
            } 
        } else {
            if (steps[1].unit === 'Km') {
              stepFrequency = steps[1].init +' '+'km / '+steps[0].init+' '+this.translationService.instant('dimbo.i18n.label.fequency.years')+' '+this.translationService.instant('dimbo.i18n.label.fequency.then')+' '+this.translationService.instant('dimbo.i18n.label.fequency.every')+' '+ steps[1].cycle+' km / '+steps[0].cycle+' '+this.translationService.instant('dimbo.i18n.label.fequency.years');  
              } else {
              stepFrequency = steps[1].init +' '+'mi / '+steps[0].init+' '+this.translationService.instant('dimbo.i18n.label.fequency.years')+' '+this.translationService.instant('dimbo.i18n.label.fequency.then') +' '+' '+this.translationService.instant('dimbo.i18n.label.fequency.every') +' '+ steps[1].cycle+' mi / '+steps[0].cycle+' '+this.translationService.instant('dimbo.i18n.label.fequency.years');  
          } 
        }
        }
      } else { // if there's no cycle value, only init is present
        // case 1: When initial period &/or mileage is same as that of Cyclical values of period &/or mileage 
        //if ((steps[0].init === steps[0].init) || (steps[1].init === steps[1].cycle)) {
          if (steps[1].unit === 'Km') {
            stepFrequency = steps[1].init +' '+'km / '+steps[0].init+' '+this.translationService.instant('dimbo.i18n.label.fequency.years');  
          } else {
            stepFrequency = steps[1].init +' '+'mi / '+steps[0].init+' '+this.translationService.instant('dimbo.i18n.label.fequency.years');   
          }  
        //} 
      }

        

         

    } else if (steps.length === 3) {

    } else {

    }
    return stepFrequency;

  }

  createService() {
    let showAdditionalInfoDialog: boolean = false;
    /* Check in cache whether the following information is available or not -
      * isCustomerVerified 
      * customerlastName
      * customerEmail
      * registration
      * firstRegistrationDate
      * currentMillage
      * millageUnit
    */
   this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CREATE_CURRENT_USAGE, this.usage);
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_CUSTOMER_VERIFIED)) {
      showAdditionalInfoDialog = true;
      this.showCurrentService = true;
      this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CREATE_SERVICE_SCOPE, this.showCurrentService);
      this.createServiceScope = true;
    } 

    if (!showAdditionalInfoDialog) {
      if(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT) >0 ){
        this.openDialogBox('POPUP_VIEW');
      }else {
        this.toastrService.error(this.translationService.instant('dimbo.i18n.message.CustomerVerificationmsg'), '',{
          timeOut: 500000,
        });
        this.onPageLoad();
      }
    }
    
  }

  /* Open popup for additional information */
  openDialogBox(eventName: string, additionalInfo?: any, isCustVerified?: boolean) {
    const popupData = { eventName: eventName, additionalInfo: additionalInfo, isCustVerified: isCustVerified };
    this.additionalInfoDialogBoxRef = this.matDialog.open(AdditionalInfoDialogBoxComponent, {
      disableClose: true,
      minWidth: '450px',
      minHeight: '550px',
      data: popupData
     // backdropClass: 'custom-dialog'
    });

    this.additionalInfoDialogBoxRef.afterClosed().subscribe((result: any) => {
      if (result) { 
        if (result.event.eventName === 'POPUP_OK') {
          if (result.event.isCustVerified) { 
            this.showCurrentService = true;
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CREATE_SERVICE_SCOPE, this.showCurrentService);
            this.createServiceScope = true;
            // Emit DB changes
            this.additionInfoUpdated.emit({isAdditionInfoUpdated: true});
          } else {
            let currentRetryCount = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT) - 1;
            this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT, currentRetryCount);

            if (currentRetryCount < 1) {
              this.toastrService.error(this.translationService.instant('dimbo.i18n.message.CustomerVerificationFinalAttempt'), '',{
                timeOut: 50000,
              });
            } else {
              this.toastrService.error(this.translationService.instant('dimbo.i18n.message.CustomerVerificationFailed')+' '+currentRetryCount+this.translationService.instant('dimbo.i18n.message.CustomerVerificationFailed1'), '',{
                timeOut: 5000,
              });
            }

            this.resetMaintenance();
          }
          
        }
      }
    });
  }


  onServiceListControlChanged(services, index) {
   // console.log('services: ', services._value);
    this.selectedOption = services.selectedOptions.selected.map(item => item.value);
 //  console.log('index: ', index);
    this.selectedOpsForIndex.push(services._value);

    this.filteredOption = this.typesOfServices.filter( i => this.selectedOption.includes( i.id ) );

    /* this.filteredOption = this.typesOfServices.filter(function(item){
      return this.selectedOption.indexOf(item.id) > -1;
    }); */
    
    this.filteredOption = this.filteredOption.reduce((unique, o) => {
      if(!unique.some(obj => obj.id === o.id)) {
        unique.push(o);
      }
      return unique;
  },[]);

    //.log('selectedOption: ', this.selectedOption);
  //  console.log('selectedOpsForIndex: ', this.selectedOpsForIndex);

    if(!this.storedIndexArr.includes(index)){          //checking weather array contain the id
      this.storedIndexArr.push(index);               //adding to array because value doesnt exists
    }else{
      this.storedIndexArr.splice(this.storedIndexArr.indexOf(index), 1);  //deleting
    }
   // console.log('storedIndexArr: ', this.storedIndexArr);

  }

  addService() {
   // console.log('filteredOption: ', this.filteredOption);
    if (this.filteredOption.length > 0) {

      for(let i = 0; i < this.selectedOpsForIndex.length; i++){
        const operationRefId = this.selectedOpsForIndex[i];
        this.storedIndexObj[operationRefId] = this.storedIndexArr[i];
      }

      for(const operation of this.filteredOption) {
        const operationlocal = this.getOperation(operation);  
        this.singleserviceoperation.push(operationlocal);
      }
    
      for(const operation of this.filteredOption){
        const index = this.typesOfServices.indexOf(operation, 0);
        if (index > -1) {
          this.typesOfServices.splice(index, 1);
        }
      }
      this.filteredOption.length = 0;
      this.selectedOption.length = 0;
    //  console.log('After adding ops: ', this.storedIndexObj);
    }
  }


  getOperation(filteredOption: any){
    let elm: any = {
      maintenancePlanReference : filteredOption.id ,
      label: filteredOption.serviceName ,
      source : filteredOption.source ,
      typeCode : filteredOption.typeCode,
      statusCode : filteredOption.statusCode,
      //statusLabel : this.getStatusLabel(filteredOption.statuslabel),
      statusLabel : filteredOption.statusLabel,
      stepFrequency : filteredOption.stepFrequency
    };
   return elm;
  }

  onServiceOperationChanged(operation){
   // console.log('on removing operation: ', operation);
    const servicelocal = this.getService(operation);
    this.typesOfServices.push(servicelocal);

    const index = this.singleserviceoperation.indexOf(operation, 0);
    if (index > -1) {
      this.singleserviceoperation.splice(index, 1);
    }
  }

  getService(operation){
    let elm: any = {};
    elm.id=operation.maintenancePlanReference;
    elm.serviceName = operation.label;
    //elm.statusLabel = this.getStatusLabel(operation.statusLabel);
    elm.statusCode = operation.statusCode;
    elm.statusLabel = operation.statusLabel;
    elm.stepFrequency = operation.stepFrequency;
   return elm;
  }

  setAntiperforation(event)
  {
    if(event.checked){
       this.isAntiPerforationCheck=true;
    }else{
      this.isAntiPerforationCheck=false;
    }
  }

  setIssueDetected(event)
  {
    if(event.checked){
       this.issueDetected=true;
    }else{
      this.issueDetected=false;
    }
  }


  onSubmit(form: NgForm) {
    if(this.singleserviceoperation.length==0){
      this.toastrService.warning('Please select one Operation');
      return;
    }
    this.spinner.show();
    let submitUsage=!this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CREATE_CURRENT_USAGE) ? 'NORMAL' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CREATE_CURRENT_USAGE);
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) === 'OV') {
      submitUsage = 'NA'; 
    }
    let params: any = {
      vin:  !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN) ? 'VF30U9HR8AS274264' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN),
      contractNumber: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CONTRACT_ID) ? '623256801' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CONTRACT_ID),
      serviceHistory :{
        date: _moment(new Date()).format("YYYY-MM-DD[T]HH:mm:ss")+'Z',
        mileage: {
          value:  !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE),
          unit: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT)
        },
        updatedBy: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_USER_ID) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_USER_ID),
        updatedOn: _moment(new Date()).format("YYYY-MM-DD[T]HH:mm:ss")+'Z', //moment().format("YYYY-MM-DD[T]HH:mm:ss");
        usage: submitUsage,
        operation:this.singleserviceoperation,
        antiperforation:{
          antiPerforationCheck: this.isAntiPerforationCheck,
          period : !form.value.antiperforationperiod ? null : form.value.antiperforationperiod,
          comment : !form.value.antiperforationcomment ? null : form.value.antiperforationcomment,
          issueDetected: this.issueDetected
        },
        repairer: {
          repairerID: this.getRepairerId(),
          name: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_NAME) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_NAME),
          city: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_CITY) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_CITY),
          address: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_ADDRESS) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_ADDRESS),
          zipCode: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_ZIP) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_ZIP),
          brand: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND),
          authorizedDealer: this.getAuthorizedDealer(),
          country: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY),
          physicalSiteCode: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_PHYSICAL_SITE) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_PHYSICAL_SITE),
        },
        comment:form.value.servicehistorycomment,

      }
    };

    this.maintenancePlanService.addServicePlan(params)
        .subscribe(response => {
        this.spinner.hide();
        // Now reset cunnrent tab & then switch to 1st tab 
        //this.onPageLoad();
        this.resetMaintenance();
        this.switchToFirst.emit({isSwitchToFirst: true});
        //this.onaddServiceReload.emit({reloadFirstTab: false});
        this.toastrService.success(this.translationService.instant('dimbo.i18n.message.record.success')); 
        
      }, error => {
        this.createServiceScope = false;
        if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503) && error.error) {
          this.spinner.hide();
          this.toastrService.error(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.toastr.error'));
      } else {
          this.spinner.hide();
          this.toastrService.error(this.translationService.instant(error.error.message), this.translationService.instant('dimbo.i18n.message.toastr.error'));
      }
    });
    //this.ngOnInit();
    //this.switchToFirst.emit({isSwitchToFirst: true});  

  }

  getAuthorizedDealer(): boolean {
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION)) {
      if ((this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION) === 'HUB') || 
          (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION) === 'hub')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  // set contractID in cache
  setContractId() {
    /* let params: any = {
      sourceApplication : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION)
    } */
    this.spinner.show();
    this.commonService.getDimboContract().subscribe((result)=> {

      if (result) {
        // now set contract info in cache
        this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CONTRACT_ID, result.dimboData.contractNumber);
        this.spinner.hide();
      }

      }, error => {
            if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503 || error.status === 404) && error.error) {
              this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.ActiveContract'), this.translationService.instant('dimbo.i18n.message.toastr.warning'), {
                timeOut: 10000,
              });
              this.spinner.hide();
          } else {
              this.toastrService.error(this.translationService.instant('dimbo.i18n.message.ActiveContract'), this.translationService.instant('dimbo.i18n.message.toastr.error'), {
                timeOut: 10000,
              });
              this.spinner.hide();
          }
        }
    );
  }

  resetMaintenance () {
    this.usage='NORMAL';
    this.selectedVal = 'NORMAL';
    this.getMaintenancePlan('NORMAL');
    this.showCurrentService = false;
    this.cacheService.setItem(DIMBO_CONSTANT.CACHE_CREATE_SERVICE_SCOPE, this.showCurrentService);
   // this.cacheService.removeItem(DIMBO_CONSTANT.CACHE_CREATE_CURRENT_USAGE);
    this.issueDetected = false;
    this.antiperforationcomment = '';
    this.antiperforationperiod = this.getVehicleAge();
    this.servicehistorycomment = '';
    this.singleserviceoperation = [];
    this.isAntiPerforationCheck = false;
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) === 'OV' && this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_OV_LEGACY)) {
      this.vehicleBrandIsNotOV = false; 
    }
    this.customerVeficationRetryCount = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT);
  }

  getRemainingRetryCount(): boolean {
    
    let remainingRetryCount: number = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT);
    if (remainingRetryCount < 1) {
      return false;
    } else {
      true;
    }
  }

  getRepairerId(): string {
    let repairerId = '';
    if (this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION) === 'HUB' || this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION) === 'hub' 
    || this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION) === 'LINK' || this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION) === 'link') {
      repairerId = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_RRDI);
    } else {
      repairerId = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_POS);
    }
    return repairerId;
  }

  callMaintenancePlan(usage: string){
    this.usage = usage;
    this.spinner.show();
    this.typesOfServices.length = 0;
    this.numberOfServices.length = 0;
    this.antiperforationperiod = this.getVehicleAge();
    let vehicleMilleageUnite = 'yr,'+ this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE_UNIT);

    let params: any = {
      language : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL),
      country: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY),
      unit: vehicleMilleageUnite,
      usage: usage,
      brand: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) ? 'AP' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND),
      mileage: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE),
      firstRegistrationDate: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE)
    }

    this.maintenancePlanService.getMaintenancePlan(params)
      .subscribe(response => {
        this.maintenanceServices = response;
        if (response && response.maintenancePlans[0].operations) {
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH, response.doesMileageUnitMatch);
          this.cacheService.setItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL, response.frequencyMileageUnit);
          for (const operation of response.maintenancePlans[0].operations) {
            let elm: any = {};
            elm.id = operation.reference;
            elm.serviceName = operation.operationLabel;
            elm.order = operation.order;
            elm.statusCode = operation.planningStatus?.code;
            elm.statusLabel = this.getStatusLabel(operation.planningStatus?.label);
            elm.stepFrequency = this.getStepFrequency(operation.steps);
            elm.source = !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION) ? null : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION);
            elm.typeCode = '';
            
            this.services.push(elm);
          }
          this.hasPlanned=this.services.reduce((prev, service) => prev || service.statusLabel, false);
          this.normalHasdata=true;
          this.typesOfServices = this.services;
          this.numberOfServices.push(this.services);
          //this.numberOfServices = this.services;
          if(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL)!==undefined){
            if(!this.cacheService.getItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH)){
            this.additionInfoUpdated.emit({isAdditionInfoUpdated: true});
            }
          }
          this.spinner.hide();
        } else {

          if(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_MP_CALL_FIRST_TIME)) {


            let paramsSevere: any = {
              language : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL),
              country: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY),
              unit: vehicleMilleageUnite,
              usage: 'SEVERE',
              brand: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) ? 'AP' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND),
              mileage: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE),
              firstRegistrationDate: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE)
            }

            this.maintenancePlanService.getMaintenancePlan(paramsSevere)
            .subscribe(response => {
              //this.maintenanceServices = response;
              if (response && response.maintenancePlans[0].operations) {
                this.cacheService.setItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH, response.doesMileageUnitMatch);
                this.cacheService.setItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL, response.frequencyMileageUnit);
                this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_MP_CALL_FIRST_TIME, false);
                this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_MP_SEVERE_HAS_DATA, true);
                this.isMpSevereHasData = true;
                //this.typesOfServices = this.services;
                //this.numberOfServices.push(this.services);
                this.spinner.hide();
              }
            }, error => { 

            });


          }

          this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.MP.vin'), this.translationService.instant('dimbo.i18n.message.toastr.warning'), {
            timeOut: 10000,
          });
        }
                
        }, error => {

          if(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_IS_MP_CALL_FIRST_TIME)) {


            let paramsSevere: any = {
              language : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL),
              country: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY),
              unit: vehicleMilleageUnite,
              usage: 'SEVERE',
              brand: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND) ? 'AP' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND),
              mileage: this.cacheService.getItem(DIMBO_CONSTANT.CACHE_VECHILE_MILEAGE),
              firstRegistrationDate: !this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE)
            }

            this.maintenancePlanService.getMaintenancePlan(paramsSevere)
            .subscribe(response => {
              //this.maintenanceServices = response;
              if (response && response.maintenancePlans[0].operations) {
                this.cacheService.setItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH, response.doesMileageUnitMatch);
                this.cacheService.setItem(DIMBO_CONSTANT.CACHE_MILEAGE_UNIT_MATCH_VAL, response.frequencyMileageUnit);
                this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_MP_CALL_FIRST_TIME, false);
                this.cacheService.setItem(DIMBO_CONSTANT.CACHE_IS_MP_SEVERE_HAS_DATA, true);
                this.isMpSevereHasData = true;
                //this.typesOfServices = this.services;
                //this.numberOfServices.push(this.services);
                this.spinner.hide();
              }
            }, error => { 

            });


          }

          this.spinner.hide();
          if (error && error.status && (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 503 || error.status === 404) && error.error) {
            this.toastrService.warning(this.translationService.instant('dimbo.i18n.message.MP.vin'), this.translationService.instant('dimbo.i18n.message.toastr.warning'), {
              timeOut: 10000,
            });
        } else {
          this.spinner.hide();
            this.toastrService.error(this.translationService.instant('dimbo.i18n.message.record.error'), this.translationService.instant('dimbo.i18n.message.toastr.error'), {
              timeOut: 10000,
            });
        }
        });
  }

  getStatusLabel(label: string): string {
    let statuslabel = '';
    if (label === 'dimbo.i18.api.mp.ui.overdue' ){
      statuslabel = this.translationService.instant('dimbo.i18.api.mp.ui.overdue');
    } else if (label === 'dimbo.i18.api.mp.ui.tbscheduled') {
      statuslabel = this.translationService.instant('dimbo.i18.api.mp.ui.tbscheduled');  
    } else if (label === 'dimbo.i18.api.mp.ui.failed') {
      statuslabel = this.translationService.instant('dimbo.i18.api.mp.ui.failed');  
    } else if (label === 'dimbo.i18.api.mp.ui.sourcefailed') {
      statuslabel = this.translationService.instant('dimbo.i18.api.mp.ui.sourcefailed');  
    } else {
      statuslabel = '';
    }
    return statuslabel;
  }

  getVehicleAge(): number {
    let regDate = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_FIRST_REGISTRATION_DATE);
    if (regDate) {
      let regDateAr = regDate.split('-');
      let regDateYear = regDateAr[2];
      let currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      if (currentYear > regDateYear){
        let vehicleAge = this.diff_years( currentDate ,regDate);
       // console.log('vehicleAge: ', vehicleAge);
        if( vehicleAge > 0 && vehicleAge <= 10 ) {
          return vehicleAge;
        } else if (vehicleAge >= 10) {
          this.greaterage=vehicleAge;
          return vehicleAge;
        } else {
          return 1;
        }
      } else {
        return 1;
      }
    } else{
      return 1;
    }
  }
   diff_years(dt2, dt1) 
 {
  var diff =(new Date(dt2).getTime() - new Date(dt1).getTime()) / 1000;
   diff /= (60 * 60 * 24);
   diff/=365.25;
  return Math.abs(Math.round(Math.trunc( diff )));
   
 }

}
